import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { FiHome, FiKey, FiFileText, FiCheckSquare, FiUsers, FiShield, FiCreditCard, FiSettings, FiAward } from 'react-icons/fi';
import { AppContext } from '../../context/AppContext';
import useAuth from '../../hooks/useAuth';
import { ROLES, ROUTES } from '../../utils/constants';
import './Sidebar.css';

const Sidebar = () => {
  const { sidebarOpen, setSidebarOpen } = useContext(AppContext);
  const { user, userRole } = useAuth();

  const closeSidebar = () => {
    if (window.innerWidth < 768) setSidebarOpen(false);
  };

  const navItems = [
    { path: ROUTES.DASHBOARD, label: 'Dashboard', icon: <FiHome />, roles: Object.values(ROLES) },
    { path: ROUTES.PROPERTIES, label: 'Properties', icon: <FiKey />, roles: [ROLES.OWNER, ROLES.ADMIN, ROLES.AGENT] },
    { path: ROUTES.APPLICATIONS, label: 'Applications', icon: <FiFileText />, roles: [ROLES.OWNER, ROLES.ADMIN, ROLES.AGENT] },
    { path: ROUTES.APPLICANT_PORTAL, label: 'My Applications', icon: <FiFileText />, roles: [ROLES.APPLICANT] },
    { path: ROUTES.PASSPORT, label: 'Tenant Passport', icon: <FiAward />, roles: [ROLES.APPLICANT] },
    { path: ROUTES.MY_DATA, label: 'My data', icon: <FiShield />, roles: [ROLES.APPLICANT] },
    { path: ROUTES.ORGANISATION, label: 'Organisation', icon: <FiSettings />, roles: [ROLES.OWNER, ROLES.ADMIN, ROLES.AGENT, ROLES.VERIFIER, ROLES.READONLY] },
    { path: ROUTES.ADMIN_MANDATES, label: 'Mandate reviews', icon: <FiShield />, platformAdmin: true },
    { path: ROUTES.PROPERTY_APPLICANTS, label: 'Applicants', icon: <FiUsers />, roles: [ROLES.OWNER, ROLES.ADMIN, ROLES.AGENT] },
    { path: ROUTES.VERIFICATION, label: 'Verification', icon: <FiCheckSquare />, roles: [ROLES.VERIFIER, ROLES.ADMIN, ROLES.OWNER] },
    // Disputes are always about one specific application (the API has no cross-application
    // listing) — reached from within that application's own page, not as a flat sidebar link.
    // An applicant raises one from ApplicantApplicationPage; owner/admin review it at
    // ROUTES.DISPUTES (/applications/:id/disputes) from within that application's detail view.
    { path: ROUTES.BILLING, label: 'Billing', icon: <FiCreditCard />, roles: [ROLES.OWNER, ROLES.ADMIN] },
    { path: ROUTES.ADMIN, label: 'Admin Hub', icon: <FiSettings />, roles: [ROLES.COMPLIANCE_ADMIN, ROLES.ADMIN] },
    { path: ROUTES.AUDIT, label: 'Audit Log', icon: <FiShield />, roles: [ROLES.COMPLIANCE_ADMIN, ROLES.ADMIN] },
  ];

  const visibleItems = navItems.filter((item) =>
    item.platformAdmin ? !!user?.is_platform_admin : item.roles.includes(userRole)
  );

  return (
    <>
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar}></div>}
      <aside className={`sidebar ${sidebarOpen ? 'sidebar--open' : ''}`}>
        <nav className="sidebar__nav">
          <ul className="sidebar__list">
            {visibleItems.map(item => (
              <li key={item.path} className="sidebar__item">
                <NavLink to={item.path} className={({ isActive }) => `sidebar__link ${isActive ? 'sidebar__link--active' : ''}`} onClick={closeSidebar}>
                  <span className="sidebar__icon">{item.icon}</span>
                  <span className="sidebar__label">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
